<template>
	<ul class="content_left">
	  <li
	      :class="$route.query.plateId == item.id ? 'left_nav_active left_nav':'left_nav'"
	      v-for="item in articleListNav.children" :key="item.id">
	    <router-link v-if="item.id == 4" :to="{path:'/location',query:{menuId:8,plateId:4}}">
	      <span class="nav_name">地理位置  &nbsp;</span>
	      <img class="nav_img" src="../assets/images/article/navRight.png" alt="">
	      <img class="white" src="../assets/images/article/whiteRight.png" alt="">
	    </router-link>
	    <router-link v-else-if="item.id == 5" :to="{path:'/park_honor',query:{menuId:8,plateId:5}}">
	      <span class="nav_name">园区荣誉  &nbsp;</span>
	      <img class="nav_img" src="../assets/images/article/navRight.png" alt="">
	      <img class="white" src="../assets/images/article/whiteRight.png" alt="">
	    </router-link>
	    <router-link v-else-if="item.id == 7" :to="{path:'/applyForEnter',query:{menuId:15,plateId:7}}">
	      <span class="nav_name">申请入驻  &nbsp;</span>
	      <img class="nav_img" src="../assets/images/article/navRight.png" alt="">
	      <img class="white" src="../assets/images/article/whiteRight.png" alt="">
	    </router-link>
      <router-link v-else-if="item.id == 31" :to="{path:'/patentSearch',query:{menuId:30,plateId:31}}">
	      <span class="nav_name">院校机构  &nbsp;</span>
	      <img class="nav_img" src="../assets/images/article/navRight.png" alt="">
	      <img class="white" src="../assets/images/article/whiteRight.png" alt="">
	    </router-link>
      <router-link v-else-if="item.id == 32" :to="{path:'/patentSearch/AllPatent',query:{menuId:30,plateId:32}}">
	      <span class="nav_name">所有专利  &nbsp;</span>
	      <img class="nav_img" src="../assets/images/article/navRight.png" alt="">
	      <img class="white" src="../assets/images/article/whiteRight.png" alt="">
	    </router-link>
	    <router-link v-else :to="{path:'/articleList',query:{menuId:articleListNav.menuId,plateId:item.id}}">
	      <span class="nav_name">{{item.plateName}}  &nbsp;</span>
	      <img class="nav_img" src="../assets/images/article/navRight.png" alt="">
	      <img class="white" src="../assets/images/article/whiteRight.png" alt="">
	    </router-link>
	  </li>
	  <p class="search_box">
	    <input class="search" type="text" v-model="search"  @keyup.enter="goSearch">
	    <img @click="goSearch" class="search_img" src="../assets/images/article/search.png" alt="">
	  </p>
	</ul>
</template>
<script>
export default {
	props:{
		articleListNav: Object
	},
	data(){
		return{
			search: '',
		}
  },
  methods:{
    goSearch(){
      console.log(this.$route)
      if(this.search === ''){
        return
      }
      let params = {
        menuId: this.articleListNav.menuId,
        plateId: this.$route.query.plateId,
        search: this.search
      }
      //专利检索版块搜索添加指定参数
      if( this.$route.query.menuId = 30){
        params.patent = 1
      }
      this.$router.push({
        path: '/search',
        query: params
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.content_left {
  width: 188px;
  background: url("../assets/images/article/listBg.png") no-repeat;
  .left_nav {
    a {
      width: 100%;
      height: 100%;
      display: inline-block;
      font-size: 16px;
      color: #333;
    }
    width: 160px;
    height: 40px;
    font-size: 16px;
    color: #333;
    text-align: center;
    line-height: 40px;
    background-color: #fff;
    margin-top: 10px;
    cursor: pointer;
    position: relative;
    .nav_img {
      width: 7px;
      height: 11px;
    }
    .white {
      width: 7px;
      height: 11px;
      position: absolute;
      top: 16px;
      right: 4px;
      display: none;
    }
  }
  .left_nav_active {
    background-color: $themeColor;
    a {
      width: 100%;
      height: 100%;
      display: inline-block;
      color: #fff;
    }
    .nav_img {
      display: none;
    }
    .white {
      display: block;
    }
  }
  .left_nav:hover {
    background-color: $themeColor;
    a {
      color: #fff;
    }
    .nav_img {
      display: none;
    }
    .white {
      display: block;
    }
  }
  .left_nav:first-of-type {
    margin-top: 25px;
  }
  .search_box {
    position: relative;
    .search {
      width: 160px;
      height: 40px;
      margin-top: 25px;
      border-radius: 25px;
      border: 1px solid #ccc;
      padding-left: 10px;
    }
    .search_img {
      width: 22px;
      height: 21px;
      position: absolute;
      right: 34px;
      top: 34px;
      cursor: pointer;
    }
  }
}
</style>